import PlaceholderImage from '../../../atoms/placeholderImage/PlaceholderImage';
import { Text } from '../../../typography/text/Text';
import LinkToWishlist from '@srcDS/components/molecules/linkToWishlist/LinkToWishlist';
import ProductImage from '../../cartPage/cartItem/components/ProductImage';
import ProductName from '../../cartPage/cartItem/components/ProductName';
import ProductOption from '../../cartPage/cartItem/components/ProductOption';
import ProductPrice from '../../cartPage/cartItem/components/ProductPrice';
import CartPromotion from '../../cartPage/cartItem/components/CartPromotion';
import RemoveButton from '../../cartPage/cartItem/components/RemoveButton';
import SelectQuantity from '../../cartPage/cartItem/components/SelectQuantity';
import styles from './MinicartItem.module.scss';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { Link } from '../../../atoms/link/Link';
import { getPrices } from '../../../../utils/helpers';
import PromotinalTag from '../../../atoms/promotinalTag';
import { FinalSaleDescription } from '../../../atoms/finalSale';
import DiscountTag from '../../../atoms/discountTag/DiscountTag';

const MiniCartItem = ({
  item = {},
  capitalize = () => {},
  onQtyUpdate = () => {},
  removeFromCart = () => {},
  setShowDialog = () => {},
  setLoading,
  discounts,
  toSignUp,
}) => {
  const { list: discountsList = [], codes = [] } = discounts;
  const {
    discounts: itemDiscounts,
    projectSpecificData: { url, availableQuantity, discount = {}, prices = [], variants },
    count,
    totalPrice,
    discountedPrice: originalDiscountedPrice,
  } = item;

  const cartDiscount = useMemo(() => {
    const promo =
      discountsList &&
      discountsList.find(
        (d) =>
          discountsList &&
          itemDiscounts &&
          itemDiscounts.find((item) => item.discountId === d.id) &&
          ((codes && !codes.find((c) => c.originalId === d.id)) || !codes),
      );

    return !!promo && promo.type === 'cart-discount' ? promo : null;
  });

  let discountedPrice = originalDiscountedPrice;
  const { onSale, price } = getPrices(prices);

  if (!discountedPrice && !cartDiscount) {
    discountedPrice = getPrices(prices)?.discountedPrice;
  }

  const variant = useMemo(() => {
    if (!variants) return {};
    return variants.find((v) => v.id === item.variant.id);
  }, [variants]);

  const isOutOfStock = variant?.projectSpecificData?.availableQuantity === 0 || false;
  const isInsufficientStock = !isOutOfStock && variant?.projectSpecificData?.availableQuantity < count;
  const finalSaleDescription = item.projectSpecificData?.attributes?.find((att) => att.name === 'finalsalemessage');

  return (
    <div className={styles.cartItem}>
      {cartDiscount && <CartPromotion data={cartDiscount} />}
      <div className={styles.product} id={item.lineItemId}>
        <Link link={url} onClick={() => setShowDialog(false)}>
          {item.variant && item.variant.images[0] ? (
            <ProductImage
              customClasses={{
                productImage: styles.productImage,
              }}
              alt={item.name}
              image={item.variant && item.variant.images[0]}
            />
          ) : (
            <div className={styles.productImage}>
              <PlaceholderImage />
            </div>
          )}
        </Link>
        <div className={styles.productContent}>
          <div className={styles.productNameAndRemove}>
            {item.name && (
              <Link link={url} onClick={() => setShowDialog(false)}>
                <ProductName className={styles.productName} name={item.name} />
              </Link>
            )}
            <RemoveButton
              placement="minicart"
              removeFromCart={(uniqId) => removeFromCart(uniqId, item)}
              uniqueId={item.lineItemId}
              fill="#949494"
            />
          </div>
          <div className={styles.productOptions}>
            {isOutOfStock && <Text className={styles.outOfStock}>Out of stock</Text>}
            {isInsufficientStock && (
              <Text className={styles.outOfStock}>Only {variant.projectSpecificData.availableQuantity} available</Text>
            )}
            {item.variant && item.variant.attributes && item.variant.attributes.size && (
              <ProductOption label="Size" color={item.variant.attributes.size.label} capitalize={capitalize} />
            )}
            {item.variant && item.variant.attributes && item.variant.attributes.colour && (
              <ProductOption label="Colour" color={item.variant.attributes.colour} capitalize={capitalize} />
            )}
            {discount?.name ? (
              <PromotinalTag data={discount} placement="miniCart" />
            ) : discountedPrice ? (
              <DiscountTag
                fullPrice={price}
                discountPrice={discountedPrice}
                onSale={onSale}
                customStyles={styles.discountTag}
                placement="miniCart"
              />
            ) : null}
          </div>
          <div className={styles.footer}>
            <SelectQuantity
              selectHeight="33px"
              customClasses={{
                qtySelector: styles.qtySelector,
              }}
              selectQuantityVariant="normal"
              selectQuantityLabelPosition="normal"
              selectQuantityDefaultValue={item.count}
              availableQuantity={availableQuantity}
              isOutOfStock={isOutOfStock}
              isInsufficientStock={isInsufficientStock}
              onSelect={(e) => {
                onQtyUpdate(item, e.target.value);
              }}
            />
            <div className={styles.wishlistAndSubtotal}>
              <ProductPrice
                placement="minicart"
                onSale={onSale}
                fullPrice={discountedPrice ? price * count : totalPrice}
                discountPrice={discountedPrice ? totalPrice : null}
              />

              <LinkToWishlist
                item={item}
                lineItemId={item.lineItemId}
                toSignUp={toSignUp}
                setLoading={setLoading}
                customClasses={{
                  linkToWishlist: styles.linkToWishlist,
                }}
              />
            </div>
          </div>
        </div>
      </div>
      {finalSaleDescription && (
        <FinalSaleDescription
          description={finalSaleDescription?.value}
          className={{
            root: styles.finalSaleDescription_root,
            finalSale: styles.finalSaleDescription_finalSale,
            description: styles.finalSaleDescription_description,
          }}
        />
      )}
    </div>
  );
};

MiniCartItem.propTypes = {
  item: PropTypes.object,
  capitalize: PropTypes.func,
  removeFromCart: PropTypes.func,
  setShowDialog: PropTypes.func,
};

export default MiniCartItem;
